import { combineReducers } from 'redux';
import swaps from '../pages/Requests/reducers';
import bulkOperations from '../pages/BulkOperationsUpload/reducers';
import migrateToIB from '../pages/MigrateToIB/reducers/migrateToIB';
import bulkMigrateToIB from '../pages/MigrateToIB/reducers/bulkMigrateToIB';

const reducer = combineReducers({ swaps, bulkOperations, migrateToIB, bulkMigrateToIB });

export default reducer;
